export default function getRuntimeEnv(): Partial<any> {
  if (typeof window === "undefined") return process.env;
  return { ...process.env, ...(window as any).process.env };
}
